import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const UpdateTodoEvent = declareEvent('update-todo', {
  id: string(),
  title: string(),
});
export type UpdateTodoEvent = TypeOfEvent<typeof UpdateTodoEvent>;
